import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { StorageService } from './storage.service';
import { Router } from '@angular/router';
import { ButtonCooldownService } from './button-cooldown.service';
import { SessionCleanupService } from './session-cleanup.service';

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    constructor(
        private apiService: ApiService,
        private router: Router,
        private storageService: StorageService,
        private buttonCooldown: ButtonCooldownService,
        private sessionCleanup: SessionCleanupService,
    ) {}

    hasPermission(screenId: string): boolean {
        const stored = localStorage.getItem('menuItems');
        if (!stored) {
            return false;
        }
        return stored.split(',').includes(String(screenId));
    }
    menuPermission(menus: []) {
        // console.log("Menus : ", menus);
        return menus.filter((menuObj: any) => menuObj['create_permission'] || menuObj['delete_permission'] || menuObj['read_permission'] || menuObj['update_permission'])
    }


    forceLogout(reason = '-2') {
        localStorage.setItem('screenId', reason);
        this.apiService.onLogout({}).subscribe({
            next: () => this.sessionCleanup.cleanUpAndRedirect({ screenId: reason }),
            error: () => this.sessionCleanup.cleanUpAndRedirect({ screenId: reason }),
        });
    }

    cleanUpAndRedirect() {
        this.sessionCleanup.cleanUpAndRedirect();
    }

}

